import {getCountries} from 'libphonenumber-js/core';
import libPhoneNumberMetadata from 'libphonenumber-js/max/metadata';
import {createViewConfig} from '@sail/engine';
import type {CountryCode as PhoneNumberCountryCode} from 'libphonenumber-js/core';
import type {PhoneNumberFieldProps} from './PhoneNumberField';

export type {CountryCode as PhoneNumberCountryCode} from 'libphonenumber-js/core';

/**
 * @deprecated Use `PhoneNumberCountryCode` instead
 */
export type CountryCode = PhoneNumberCountryCode;

export const PHONE_NUMBER_ALL_COUNTRIES: PhoneNumberCountryCode[] =
  getCountries(libPhoneNumberMetadata);

export const PhoneNumberFieldConfig = createViewConfig({
  props: {} as PhoneNumberFieldProps,
  name: 'PhoneNumberField',
  flattens: true,
  defaults: {
    countryAllowlist: PHONE_NUMBER_ALL_COUNTRIES,
    size: 'medium',
    defaultCountry: 'US',
  },
});
